import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const QUALIFY_IMG = 'https://cdn.magicpatterns.com/uploads/4MdRZb1jhDdm5GHEsX3zn9/vitaly-gariev-FAhkBXFOkDE-unsplash.jpg';
export function Qualify() {
  const programs = ['SNAP / Food Stamps', 'Medicaid', 'WIC', 'SSI', 'Federal Public Housing Assistance', 'Veterans Pension or Survivor Benefits', 'Lifeline Benefit', 'Income-based eligibility'];
  return <section id="qualify" className="flex flex-col md:flex-row min-h-[600px]" data-id="element-135">
      {/* Mobile Image (shows first on mobile) */}
      <div className="md:hidden w-full h-[300px]" data-id="element-136">
        <img src={QUALIFY_IMG} alt="Family using devices" className="w-full h-full object-cover" data-id="element-137" />
      </div>

      {/* Left Panel - Gold */}
      <div className="w-full md:w-[45%] bg-brand-gold py-16 md:py-24 px-4 sm:px-6 lg:px-16 flex flex-col justify-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-139">
          <p className="text-brand-black font-bold tracking-widest uppercase text-sm mb-4" data-id="element-140">
            Do You Qualify
          </p>
          <h2 className="text-brand-black text-[32px] md:text-[40px] leading-tight font-serif mb-6" data-id="element-141">
            See What You Qualify For.
          </h2>
          <p className="text-brand-black/80 text-base md:text-lg mb-8 leading-relaxed font-medium" data-id="element-142">
            If you or anyone in your household participates in any of the
            following programs, you may be eligible for free or discounted
            services through Prime Nation. Check the list below and take 60
            seconds to confirm.
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-6 mb-10" data-id="element-143">
            {programs.map((program, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-144">
                <div className="bg-brand-black rounded-full p-1 mt-0.5 shrink-0" data-id="element-145">
                  <Check className="text-brand-gold" size={14} strokeWidth={3} data-id="element-146" />
                </div>
                <span className="text-brand-black font-semibold text-sm" data-id="element-147">
                  {program}
                </span>
              </li>)}
          </ul>

          <button className="w-full bg-brand-black text-brand-gold px-8 py-4 rounded font-bold text-base hover:bg-gray-900 transition-colors min-h-[52px]" data-id="element-148">
            Check My Eligibility
          </button>
        </motion.div>
      </div>

      {/* Right Panel - Image (Desktop) */}
      <div className="hidden md:block w-[55%] relative" data-id="element-149">
        <img src={QUALIFY_IMG} alt="Family using devices" className="absolute inset-0 w-full h-full object-cover" data-id="element-150" />
        <div className="absolute inset-0 bg-brand-black/10 mix-blend-overlay" data-id="element-151"></div>
      </div>
    </section>;
}